module.exports = __webpack_public_path__ + "static/exin-11d8da03d7f7d4184db3ac873415d8a6.png";